// Tabs rendered by Header.tsx and the routes each one owns. Authorization is
// per tab, not per route: a tab is granted through one DASHBOARD child program
// and owns every sub-route listed in paths.
export interface HeaderTab {
  /** Stable key for access checks in Header.tsx. */
  name: string;
  /** cm_language tag the tab is rendered with. */
  tag: string;
  /** Dashboard url the backend grants for this tab (a DASHBOARD child program). */
  grant: string;
  /** Every protected route the tab owns; these mirror the routes in main.tsx. */
  paths: string[];
}

// No dashboard tabs yet. Bookstore admin tabs (Dashboard, Catalog, Orders, ...)
// are added here together with their cm_program rows.
export const DASHBOARD_TABS: HeaderTab[] = [];

// Sections behind the Management tab, in the order Sidebar.tsx lays them out.
// Each one is granted through the child programs sharing its prefix, so a
// section opens exactly when one of those children is authorized.
export const MANAGEMENT_SECTIONS = ['/system-management'];
